import { render, staticRenderFns } from "./bookinglist.vue?vue&type=template&id=0a70cb24&scoped=true"
import script from "./bookinglist.vue?vue&type=script&lang=js"
export * from "./bookinglist.vue?vue&type=script&lang=js"
import style0 from "./bookinglist.vue?vue&type=style&index=0&id=0a70cb24&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a70cb24",
  null
  
)

export default component.exports